// extracted by mini-css-extract-plugin
module.exports = {"tablelist-container":"_2w_tZnaepkxe1QBlVBwveP","tablelist-container-footer":"_2OTv5Mv-OIt0wPwlDUZOxR","preLoaderShimmer":"Wcjn2Z3WWvUtCX3EvqO-h"};